import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { DefaultWidgetNames, WidgetType } from '@/api/rest/resources/types/widget';
import { WidgetSlotRenderer } from '@/components/widgets/WidgetSlotRenderer';
import { useWidgetSlotConfigurationByNameType } from '@/hooks/useWidgetConfigurationByOrganizationId';
import { SignedInPageLayout } from '@/layout/signed-in-page';

import { useMenuItems } from '../hooks/useMenuItems';

export const DashboardPage = () => {
  const { t } = useTranslation();
  const menuItems = useMenuItems();

  const widgetSlotsConfiguration = useWidgetSlotConfigurationByNameType(
    DefaultWidgetNames.default_template_dashboard,
    WidgetType.t_page,
  );
  return (
    <SignedInPageLayout
      items={menuItems}
      navBarProps={{
        title: t('navbar.dashboard'),
        // TODO: MVP-CW bring back when this feature is clearly spec
        // actionButton: {
        //   i18nPath: 'navbar.actionButtons.dashboard',
        //   leftAdornment: <RiAddLine size={16} />,
        // },
        showFilters: true,
      }}
    >
      <Stack spacing={10}>
        <WidgetSlotRenderer nestedWidget={widgetSlotsConfiguration} />
      </Stack>
    </SignedInPageLayout>
  );
};
